import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Icomoon__spinner",
  "use": "Icomoon__spinner-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"Icomoon__spinner\"><path d=\"M256 0C116.626 0 3.271 111.381.076 249.987 3.036 129.055 94.992 32 208 32c114.875 0 208 100.288 208 224 0 26.51 21.49 48 48 48s48-21.49 48-48C512 114.615 397.385 0 256 0zm0 512c139.374 0 252.729-111.381 255.924-249.987C508.964 382.945 417.008 480 304 480 189.125 480 96 379.712 96 256c0-26.51-21.49-48-48-48S0 229.49 0 256c0 141.385 114.615 256 256 256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol